module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/handCare@2x_4decb5.png";